import About from '../layouts/about';

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.en.js